import React from 'react';
import { Card, CardContent, Grid, CircularProgress } from '@material-ui/core';
import { LoadingCardPropTypes } from 'src/interfaces/iproptypes';
import { Skeleton } from '@mui/material';

const LoadingCard = ({ color, height, borderRadius, type, barCount, noShadow, extraStyle }: LoadingCardPropTypes) => {
  return (
    <Card style={{ borderRadius: borderRadius ? borderRadius : 'none', width: '100%', ...(noShadow && { boxShadow: 'none' }), ...(extraStyle && extraStyle) }}>
      <CardContent>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          style={{ height: height }}
        >
          {!type || type === 'circle' ? (
            <CircularProgress style={{ color: color }} />
          ) : (
            <>
              {barCount && barCount == 1 && (
                <>
                  <Skeleton
                    variant="text"
                    sx={{ fontSize: '5rem', borderRadius: 4, width: '100%' }}
                  />
                </>
              )}
              {!barCount && (
                <>
                  <Skeleton
                    variant="text"
                    sx={{ fontSize: '4rem', borderRadius: 4, width: '100%' }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width={'100%'}
                    height={80}
                    sx={{ borderRadius: 4 }}
                  />
                </>
              )}
            </>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default React.memo(LoadingCard);
